import React from 'react';
import PropTypes from 'prop-types';
// import tc from 'tinycolor2';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import LightBox from '@bd/bdui-lightbox';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
// import ContentBannerSitePlans from '../../components/ContentBannerSitePlans';
import LivingMenu from '../../components/menus/Living';
import { colors, typography } from '../../styles';


const styles = css`
  .PageSection_wrapper {
    max-width: 100%;
    padding: 20px 0;
    @media (min-width: 768px) {
      padding: 50px 0;
    }
  }
  .SitePlans {
    background-color: ${colors.color4}
  }
  .SitePlan {
    display: block;
    width: 100%;
  }
  .SiteplanImage_wrapper {
    position: relative;
    .Siteplan_image {
      background-color: #FFFFFF;
      width: 100%;
      padding: 20px;
      box-shadow: 2px 2px 15px 0 rgba(0,0,0,0.04);
      position: relative;
    }
    .SiteplanImage_expandIcon {
      position: absolute;
      bottom: 20px;
      left: 20px;
      background: ${colors.color1};
      border: 1px solid ${colors.color2Light};
      border-radius: 5px;
    }
  }
  .Location_mapRow {
    display: flex;
  }
  .Location_addressWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    text-align: center;
    width: 100%;
    flex-shrink: 0;
    margin-top: 0;
    padding: 0 40px;
    background-color: ${colors.color1Dark};
    height: 150px;
    @media (min-width: 768px) {
    width: 40%;
    height: 330px;
    }
  }
  .Location_address {
    font-family: ${typography.SansSerif};
    font-size: 16px;
    font-weight: 300;
    display: block;
    color: #FFFFFF;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    span{
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 20px;
      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }

`;

const lightboxStyles = css`
  height: 100%;
  width: 100%;
  display: block;
  padding: 15px;
  cursor: pointer;
  @media (min-width: 768px) {
    padding: 25px;
  }
`;

function OverallSitePlan({ page }) {
  // const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <LivingMenu />
      {/* <ContentBannerSitePlans
        title={get(welcome, 'title')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      /> */}
      <div className="PageSection_wrapper SitePlans">
        <div className="container">
          <div className="row">
            {
            get(page, 'site_plans') && get(page, 'site_plans').length > 0 &&
             get(page, 'site_plans').map(item => (
               <div key={item._id} className="SitePlan col-12">
                 <h3 className="PageSection_title">{item.title}</h3>
                 <LightBox className={lightboxStyles} items={[get(item, 'image')]} enableZoom>
                   <div className="SiteplanImage_wrapper">
                     <img src={get(item, 'image.contentUrl')} alt="" className="Siteplan_image" />
                     <img className="SiteplanImage_expandIcon" src="/images/i-expand.svg" alt="Expand" />
                   </div>
                 </LightBox>
               </div>
             ))
            }
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

OverallSitePlan.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'overall_site_plan',
})(OverallSitePlan);



// WEBPACK FOOTER //
// ./src/pages/OverallSitePlan/index.js